import PropTypes from 'prop-types';
import React from 'react';
import GenericFormItem from '../GenericFormItem';
import settings from '../../config/settings';
import { localize } from '../../i18n';

const Missing = function Missing(props) {
  const {
    val,
    label,
  } = props;
  if (settings.debug === false) {
    return null;
  }
  const missingLabel = (
    <em>{props.t('Missing: {label}', { label })}</em>
  );
  return (
    <GenericFormItem label={missingLabel}>
      {(typeof val === 'string') ? val : JSON.stringify(val)}
    </GenericFormItem>
  );
};

Missing.propTypes = {
  // eslint-disable-next-line
  val: PropTypes.any,
  label: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default localize(Missing);



// WEBPACK FOOTER //
// ./src/components/FormConfigs/Missing.js